import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const app = initializeApp(
  import.meta.env.MODE === "development"
    ? {
        apiKey: "AIzaSyAHEUXzc174ziJAtfjusz-kK5pwx8UhBKA",
        authDomain: "apiconnect-dev.firebaseapp.com",
        projectId: "apiconnect-dev",
        storageBucket: "apiconnect-dev.appspot.com",
        messagingSenderId: "744594391834",
        appId: "1:744594391834:web:335033b69924b3bdede2a3",
      }
    : {
        apiKey: "AIzaSyDH3n73PPGpTgS77rXN8uJPVBaxw45Dq9A",
        authDomain: "apiges-768a3.firebaseapp.com",
        projectId: "apiges-768a3",
        storageBucket: "apiges-768a3.appspot.com",
        messagingSenderId: "653888234787",
        appId: "1:653888234787:web:7dfb609e3310eaf1649896",
        measurementId: "G-S9RHZ92680",
      }
);

// const auth = getAuth(app);
// const firestore = getFirestore(app);
const storage = getStorage(app);
// const functions = getFunctions(app, "europe-west3");

export { storage };
